export default __webpack_public_path__ + "42d7e26bce0fc0825ec69a7b15796452.png";